"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TitleField = ({ title = '' }) => title ? jsx_runtime_1.jsx("p", { children: title }, void 0) : null;
exports.default = TitleField;
//# sourceMappingURL=title.js.map